// import React from "react";
// import s1 from "../assets/s1.png";
// import we1 from "../assets/we1.png";
// import we2 from "../assets/we2.png";
// import we3 from "../assets/we3.png";
// import PhoneHeader from "./PhoneHeader";

// const ATMMicro = () => {
//   const data = [
//     {
//       title: "Financial Inclusion",
//       text: "Brings banking to remote or rural areas without branches."
//     },
//     {
//       title: "Secure & Reliable",
//       text: "Uses Aadhaar authentication, reducing fraud risk."
//     },
//     {
//       title: "No Card Required",
//       text: "Works without debit/credit cards or smartphones in some cases."
//     },

//   ];
//   return (
//     <>
//      <PhoneHeader title="ATM / Micro ATM Installation" className="d-md-none d-block" />
//       <div className="container-fluid d-md-block d-none">
//         <div className="text-center top-heading section">
//           <h1>ATM / Micro ATM Installation</h1>
//         </div>
//       </div>
//       <div className="container">
//         <div className="row section align-items-center">
//           <div className="col-12 col-md-6 mb-3 mb-md-0">
//             <h1>
//               <strong>Overview</strong>
//             </h1>
//           </div>

//           <div className="col-12 col-md-6">
//             <p>
//               <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong>
//               ur platform supports digital payments via UPI along with cash
//               access through Micro ATMs — giving customers flexibility to go
//               cashless or withdraw cash conveniently. Based on PaymentHub’s
//               service model
//             </p>
//           </div>
//         </div>

//         <div className="section">
//           <img src={s1} className="w-100" />
//         </div>

//          <div className="row justify-content-center g-4">
//           <h2
//             className="mt-4 mb-5"
//             style={{ textAlign: "center", fontWeight: "600" }}
//           >
//             What We Provide
//           </h2>
//         {/* Site Evaluation & Hardware Setup */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 text-center rounded-4" style={{ backgroundColor: "#FFDED3" }}>
//             <img src={we1} alt="Site Evaluation" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Site evaluation and hardware setup.</h5>
//             <p>GST registration & return filing <br /> paymenthub</p>
//           </div>
//         </div>

//         {/* Biometric / Micro-ATM Integration */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 text-center rounded-4" style={{ backgroundColor: "#E0FBFF" }}>
//             <img src={we2} alt="Biometric Integration" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Biometric or micro-ATM integration.</h5>
//             <p>Income tax return (ITR) filing <br /> paymenthub.</p>
//           </div>
//         </div>

//         {/* Ongoing Support */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 text-center rounded-4" style={{ backgroundColor: "#EBF4E7" }}>
//             <img src={we3} alt="Ongoing Support" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Ongoing support for cash management and maintenance.</h5>
//             <p>Set up, manage, and maintain your <br /> infrastructure.</p>
//           </div>
//         </div>
//       </div>

//         {/* benefits */}
//         <div className="section d-none d-md-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="benefits-wrapper position-relative">
//             <div className="benefit"></div>
//             <div className="center-line"></div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Additional revenue stream from ATM transactions.
//                   </h5>
//                   <p className="text-start">
//                     One-stop bill payment portal for multiple services.{" "}
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">
//                     Attract more customers to your location.
//                   </h5>
//                   <p>Backed by established payment network.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Enhance your business presence as a financial service point.
//                   </h5>
//                   <p className="text-start">
//                     Agents can facilitate bill payments and earn fees. (Modelled
//                     like PaymentHub)
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>
//           </div>
//         </div>
//          <div className="section d-md-none d-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="row justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 mb-3" key={index}>
//                 <div className="benefit-box text-center p-4">
//                   <h5 className="mb-2" style={{fontWeight:"700"}}>{item.title}</h5>
//                   <p className="mb-0">{item.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ATMMicro;
import React from "react";
import s1 from "../assets/s1.png";
import solution from "../assets/solution.png";
import solution1 from "../assets/exchange.png";
import solution2 from "../assets/neural.png";
import solution3 from "../assets/cash-withdrawal.png";
import solution4 from "../assets/files.png";
import solution5 from "../assets/shield.png";
import PhoneHeader from "./PhoneHeader";
import benfits from "../assets/benfites.jpg";

const ATMMicro = () => {
  const data = [
    {
      title: "Financial Inclusion",
      text: "Brings banking to remote or rural areas without branches.",
    },
    {
      title: "Secure & Reliable",
      text: "Uses Aadhaar authentication, reducing fraud risk.",
    },
    {
      title: "No Card Required",
      text: "Works without debit/credit cards or smartphones in some cases.",
    },
    {
      title: "Commission for Agents",
      text: "Agents / BCs can earn commission on each transaction.",
    },
  ];
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1 className="mb-0">Micro ATM Services</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>W</strong> */}
              We provide Micro ATM (AEPS) services that allow customers to access
              basic banking facilities using their Aadhaar number and
              fingerprint authentication. Our services are fast, secure, and
              available anytime at your nearest outlet.
            </p>
            <ul class="list-unstyled mb-4 mb-md-0">
              <h5 className="fw-bold mt-2 mb-3">How It Works</h5>
              <li className=" mb-2">• Enter Aadhaar number</li>
              <li className=" mb-2">• Select bank name</li>
              <li className=" mb-2">• Authenticate using fingerprint</li>
              <li className=" mb-2">• Complete transaction instantly</li>
            </ul>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto" />
            </div>
          </div>
        </div>

        <div
          className="row section p-md-4 px-1 pt-5 pb-4"
          style={{ backgroundColor: "#FFF6F3" }}
        >
          <div className="col-12 col-md-6 mb-4 mb-md-0 d-md-block d-none">
            <img src={solution} alt="solution" className="img-fluid" />
          </div>

          <div className="col-12 col-md-6 m-auto">
            <h2 className="mb-md-5 mb-3 center" style={{ fontWeight: "700" }}>
              Our Micro ATM Solutions
            </h2>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution1} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Retailer & Agent Micro ATM Solution
                </h6>
                <p className="mb-0">
                  Complete Micro ATM setup for retailers, CSPs, and banking
                  correspondents with device support and backend integration.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution2} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Biometric Authentication Technology
                </h6>
                <p className="mb-0">
                  Highly secure fingerprint-based authentication ensuring safe
                  transactions.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution3} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Multi-Bank Interoperability
                </h6>
                <p className="mb-0">
                  Supports transactions across multiple banks on a single
                  platform.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution4} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Easy-to-Use Platform
                </h6>
                <p className="mb-0">
                  User-friendly interface designed for quick transactions and
                  minimal training.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="section key-features align-items-center py-md-5 p-4">
          {/* HEADING */}
          <h2 className="fw-bold text-center mb-4">
            Benefits of Our Micro ATM Services
          </h2>

          <div className="row align-items-center">
            {/* IMAGE */}
            <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
              <img
                src={benfits} // Replace with your imported image
                alt="Key Features"
                className="img-fluid img-holl"
                style={{ maxWidth: "100%", width: "100%" }}
              />
            </div>

            {/* FEATURE LIST */}
            <div className="col-12 col-md-7 m-auto">
              <ul className="list-unstyled mx-auto">
                <li className="mb-3">• No ATM card required</li>
                <li className="mb-3">• Secure biometric authentication</li>
                <li className="mb-3">• Instant cash withdrawal</li>
                <li className="mb-3">• Available for all major banks</li>
                <li className="mb-3">• Safe and reliable transactions</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ATMMicro;
